import type { Category } from '@/types/comic';

export const categories: Category[] = [
  {
    id: 'romance',
    name: '爱情',
    icon: 'ri-heart-3-line',
    description: '心动的相遇、纠结的暗恋与甜蜜的双向奔赴，收录最让人脸红心跳的恋爱韩漫。',
    subTags: ['甜宠', '暗恋', '先婚后爱', '双向奔赴'],
    color: 'primary',
  },
  {
    id: 'fantasy',
    name: '奇幻',
    icon: 'ri-magic-line',
    description: '魔法、异世界、非人类与上古契约，带你进入想象没有边界的奇幻世界。',
    subTags: ['魔法', '异世界', '契约', '非人类'],
    color: 'accent',
  },
  {
    id: 'school',
    name: '校园',
    icon: 'ri-book-2-line',
    description: '教室、天台、社团与毕业季，记录青春里那些笨拙又闪亮的瞬间。',
    subTags: ['青春', '友情', '社团', '成长'],
    color: 'secondary',
  },
  {
    id: 'urban',
    name: '都市',
    icon: 'ri-building-2-line',
    description: '职场、豪门与都市烟火气，讲述成年人在钢筋森林里的爱恨与选择。',
    subTags: ['职场', '豪门', '逆袭', '生活'],
    color: 'primary',
  },
  {
    id: 'thriller',
    name: '悬疑',
    icon: 'ri-search-eye-line',
    description: '推理、反转与心理博弈，每一话都吊足胃口，看真相如何在迷雾中浮现。',
    subTags: ['推理', '反转', '心理', '罪案'],
    color: 'accent',
  },
  {
    id: 'action',
    name: '热血',
    icon: 'ri-fire-line',
    description: '剑与魔法、江湖与修真，酣畅淋漓的对决与不屈的成长热血沸腾。',
    subTags: ['战斗', '冒险', '修真', '武侠'],
    color: 'primary',
  },
  {
    id: 'historical',
    name: '古风',
    icon: 'ri-ancient-gate-line',
    description: '唐风宋韵、江湖朝堂与仙侠奇缘，在东方美学中展开一段段传奇。',
    subTags: ['仙侠', '江湖', '权谋', '东方'],
    color: 'secondary',
  },
  {
    id: 'healing',
    name: '治愈',
    icon: 'ri-cup-line',
    description: '美食、萌宠与温柔日常，用最平淡的故事抚平一天的疲惫。',
    subTags: ['日常', '美食', '萌宠', '温暖'],
    color: 'accent',
  },
];